module.exports = __webpack_public_path__ + "img/79.aa31bfe.png";